import { useMemo } from 'react';
import type { FC } from 'react';

import { HelpImage } from '@pp/core/src/components/help/utils/HelpImage';
import { HelpText } from '@pp/core/src/services/helpTranslations/reactBindings/HelpText';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';
import { formatNumber } from '@pp/core/src/utils/formatters';

import AutoCashout from '../CrashAssets/AutoCashout.png';

export interface HelpChapterProps {
  maxMultiplier: number;
}

export const HelpChapterCrashAutoCashingOut: FC<HelpChapterProps> = ({ maxMultiplier }) => {
  const locale = useSettingsSlice.currentLanguage();

  const formattedMultiplier = useMemo(() => {
    return formatNumber(locale, Number(maxMultiplier));
  }, [locale, maxMultiplier]);

  return (
    <div>
      <p>
        <HelpText tk="autoCashoutWithoutCashout50.autoCashout" markdown />
      </p>
      <HelpImage url={AutoCashout} alt="AutoCashout" />
      <p>
        <HelpText
          dynamicValues={{ customMultiplierCap: formattedMultiplier }}
          tk="autoCashoutWithoutCashout50.minMaxVAlue"
        />
      </p>
      <p>
        <HelpText tk="autoCashoutWithoutCashout50.crashMultiplier" />
      </p>
      <p>
        <HelpText tk="autoCashoutWithoutCashout50.modifySettings" />
      </p>
    </div>
  );
};
